import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span ...attributes class=\"fly-popover__trigger\" {{did-insert @didInsertTrigger}}>\n  {{yield}}\n</span>", {
  moduleName: "@customerio/fly-components/components/fly-popover/trigger.hbs"
});